import { defineComponent as _defineComponent } from 'vue'
import { checkTemplateStatus, uploadProductionTrialImage } from '@/apis/paiban'
import { getSendCaptcha } from '@/apis/productionLineLock'
import GQRcodeAuthentication from '@/components/g-QRcode-authentication/index.vue'
import store from '@/store'
import { areaCodeOptions, isWechatQrAuthAreaCode } from '@/util/area_code'
import commonFun from '@/util/commonFun'
import { dealLayoutDataToMaterial } from '@/util/dealPaibanData'
import { uploadFileToOss } from '@yige/utils'
import type { Upload } from 'ant-design-vue'
import { Message } from 'element-ui'
import { computed, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onConfirm', 'onCancel'],
  setup(__props, { expose, emit: emits }) {


const state = reactive({
  tipText:
    '您的五/六面钻设备对接模板已被修改，请先试生产样品柜确认无误后再进行订单生产',
  isShowProductionDialog: false,
  isShowDisclaimerAgreement: false,
  previewVisible: false,
  previewImageSrc: '',
  fileList: [] as Upload['fileList'],
  isUpload: false,
  productionId: 0,
  inputPhoneNumber: '',
  countdown: 59,
  inputPassword: '',
  errInfo: {
    phone: false,
    password: false,
  },
  isShowCountDown: false,
  areaCode: '+86',
  isAuth: false,
  isShowQRCodeModal: false,
  authKey: '',
})
// lbl
let thinkerx_material = sessionStorage.getItem('thinkerx_material')
// 第三方
let third_material = sessionStorage.getItem('material_cache_data')
/** 不是第三方 且 不是老板良 ，要使用二维码鉴权 */
const isUseQrCodeAuth = computed(() => {
  // 使用二维码鉴权：非第三方/老板良，且区号为中国大陆及港澳台
  return (
    !(thinkerx_material || third_material) &&
    isWechatQrAuthAreaCode(sessionStorage.getItem('area_code'))
  )
})
function onAuthSuccess(val: any) {
  state.authKey = val
  state.isShowQRCodeModal = false
  state.isAuth = true
}
function onAuthFail(val: any) {
  state.isShowQRCodeModal = false
}
function onAuthCancel(val: any) {
  state.isShowQRCodeModal = false
}
async function handleShowQRCodeModal() {
  const res = await handleConfirm(false)
  if (!res) {
    state.isShowQRCodeModal = true
  }
}
// 生成base64
function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
// 上传图片预览
async function handlePreview(file: any) {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj)
  }
  state.previewImageSrc = file.url || file.preview
  state.previewVisible = true
}
// 图片改变
function handleChange({ fileList }: { fileList: Upload['fileList'] }) {
  state.fileList = fileList
}
// 同意并上传
async function handleConfirm(isNeedTip = true) {
  if (!state.fileList.length) return
  state.isUpload = true
  let sms_type = 'upload_trial_image'
  const params = {
    phone: state.inputPhoneNumber,
    sms_code: state.inputPassword,
    platform: 'bluen',
    sms_type,
    area_code: state.areaCode,
    nonce_str: state.authKey,
  }
  const uploadFiles = state.fileList
    .map(({ originFileObj }: any) => {
      if (!originFileObj) return
      return uploadFileToOss(
        originFileObj,
        undefined,
        undefined,
        'cloudPaibanDisclaimerAgreementPicture',
        true
      )
    })
    .filter((file) => file)
  const images = await Promise.all(uploadFiles)
  const result = await uploadProductionTrialImage({
    process_id: state.productionId,
    image_url: images.join(','),
    // 传origin字段，值为web，代表来自云排版(必传，否则来自柜柜)
    origin: 'web',
    ...params,
  })
  if (result.status !== 1) {
    state.isUpload = false
    if (result.msg == '验证码错误') {
      state.errInfo.password = true
    }
    if (isNeedTip) {
      Message.error({
        center: true,
        message: result.msg,
      })
    }
    return false
  } else {
    state.isShowProductionDialog = false
    state.isShowDisclaimerAgreement = false
    state.isUpload = false
    state.inputPassword = ''
    state.inputPhoneNumber = ''
    state.errInfo.password = false
    state.errInfo.phone = false
    emits('onConfirm')
    return true
  }
}
// 检查用户设置状态,是否唤起试生产弹窗
async function checkUserSettingStatus(settingId: number) {
  if (store.state.isTrialProduct) return false
  state.productionId = settingId
  const result = await checkTemplateStatus({
    process_id: settingId ?? store.state.ncSetting.process_setting_id,
    origin: 'web',
  })
  if (result.status !== 1) {
    state.isShowProductionDialog = true
    state.tipText = result.msg
    return true
  }
  return false
}
function handleSendCaptcha() {
  // 出现倒计时
  state.isShowCountDown = true
  var timer = setInterval(function () {
    if (state.countdown == 0) {
      clearInterval(timer)
      state.isShowCountDown = false
      state.countdown = 59
    } else {
      state.countdown--
    }
  }, 1000)
  let sms_type = 'upload_trial_image'
  let phone = state.inputPhoneNumber
  let key = {
    phone,
    sms_type: sms_type,
    area_code: state.areaCode,
  }
  let RSkey = commonFun.calcKeyByRSA(key)
  const params = {
    phone,
    sms_type: sms_type,
    area_code: state.areaCode,
    headers: {
      sign: RSkey,
    },
  }
  getSendCaptcha(params).then((res) => {
    if (res.status === 1) {
      Message.success('短信发送成功')
    } else {
      state.errInfo.phone = true
      Message.error(res.msg)
    }
  })
}
// function handleVerifiy() {
//   let sms_type = 'upload_trial_image'
//   const params = {
//     phone: state.inputPhoneNumber,
//     sms_code: state.inputPassword,
//     platform: 'bluen',
//     sms_type,
//     area_code: state.areaCode,
//   }
//   getVerifiyData(params).then((res: any) => {
//     if (!res.status) {
//       state.errInfo.password = true
//     } else {
//       handleConfirm(res.data.phone)
//     }
//   })
// }

// 弹窗关闭的回调
function handleCancel() {
  emits('onCancel')
}

// 关闭弹窗
function closeModal() {
  state.isShowProductionDialog = false
  state.isShowDisclaimerAgreement = false
}

expose({ checkUserSettingStatus, closeModal })

return { __sfc: true,emits, state, thinkerx_material, third_material, isUseQrCodeAuth, onAuthSuccess, onAuthFail, onAuthCancel, handleShowQRCodeModal, getBase64, handlePreview, handleChange, handleConfirm, checkUserSettingStatus, handleSendCaptcha, handleCancel, closeModal, GQRcodeAuthentication, areaCodeOptions, dealLayoutDataToMaterial }
}

})